export default __webpack_public_path__ + "static/media/CarImages.SeltosLarge.40e4fd38.jpg";